import { createSlice } from "@reduxjs/toolkit";
import { SuggestionsV2State } from "../interface/suggestion-v2.interface";

/*----- CREATE STORE ------*/
declare interface SuggestionsV2Slice {
    name: string;
    initialState: SuggestionsV2State;
    reducers: any;
  }
  
  const slice: SuggestionsV2Slice = {
    name: 'suggestionsV2',
    initialState: {
      suggestions: {}
    },
    reducers: {
      onSuccess: (state: SuggestionsV2State, action: any) => {
        state.suggestions[action.payload.id] = {
          data: action.payload,
          isLoaded: true,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          message: `Successfully loaded suggestions`
        }
      },
      onFailure: (state: SuggestionsV2State, action: any) => {
        state.suggestions[action.payload] = {
          data: undefined,
          isLoaded: false,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: `Failed to load suggestions`
        }
      },
      setLoading: (state: SuggestionsV2State, action: any) => {
        state.suggestions[action.payload] = {
          data: state?.suggestions[action.payload]?.data,
          isLoaded: state?.suggestions[action.payload]?.isLoaded,
          isLoading: true,
          isSuccess: state?.suggestions[action.payload]?.isSuccess,
          isFailure: state?.suggestions[action.payload]?.isFailure,
          message: `Loading suggestions`
        }
      },
      clearSuggestions: (state: SuggestionsV2State) => {
        state.suggestions = {};
      },
    },
  };
  
  export const suggestionsV2Slice: any = createSlice(slice);
  
  /*----- EXPORT ACTIONS ------*/
  export const onSuccess: Function = suggestionsV2Slice.actions.onSuccess;
  export const onFailure: Function = suggestionsV2Slice.actions.onFailure;
  export const setLoading: Function = suggestionsV2Slice.actions.setLoading;
  export const clearSuggestions: Function = suggestionsV2Slice.actions.clearSuggestions;
  
  /*----- CREATE REDUCER ------*/
  export const suggestionsV2Reducer = suggestionsV2Slice.reducer;